import { Campaign } from 'types/campaign'
import { VoohBrandNetwork } from '../../../VoohCampaign/VoohCampaignForm/types'
import { SelectAsyncValue } from '../../../../components/Form/SelectAsync'

export type FormData = {
  brandNetwork: SelectAsyncValue<VoohBrandNetwork> | null
  asIds: string
  startMonth: Campaign['startDate'] | null
  endMonth: Campaign['endDate'] | null
}

export const formDataDefault: FormData = {
  brandNetwork: null,
  asIds: '',
  startMonth: null,
  endMonth: null,
}
